export default class Folder {
  id: number | null;
  name: string;
  userId: number | null;
  conversationCount: number;
  constructor(data: any) {
    this.id = data ? data.id : null;
    this.name = data ? data.name : '';
    this.userId = data ? data.userId : null;
    this.conversationCount = data ? data.conversation_count : 0;
  }
}
